<template lang="pug">
v-btn.mr-2(@click='navigateTo' variant='outlined')
    v-icon mdi-arrow-left-circle
    span.ml-1 Back
</template>

<script lang="ts">
import { defineComponent } from 'vue';
export default defineComponent({
    name: 'ButtonIconBack',
    props: {
        routeName: {
            type: String,
            default: null,
        },
    },
    computed: {
        navigateTo() {
            if (this.routeName) {
                return () => this.$router.push({ name: this.routeName });
            }
            return () => this.$router.back();
        },
    },
});
</script>
